import Accordion from 'accordion-js';

document.querySelectorAll('.accordion--single')
  .forEach(accordion => new Accordion(accordion, {
    duration: 200,
    ariaEnabled: true,
    elementClass: 'accordion__item',
    triggerClass: 'accordion__toggle',
    panelClass: 'accordion__panel',
    activeClass: 'accordion__item--expanded',
    showMultiple: false,
  }));

document.querySelectorAll('.accordion--multiple')
  .forEach(accordion => new Accordion(accordion, {
    duration: 200,
    ariaEnabled: true,
    elementClass: 'accordion__item',
    triggerClass: 'accordion__toggle',
    panelClass: 'accordion__panel',
    activeClass: 'accordion__item--expanded',
    showMultiple: true,
  }));
